import { render, staticRenderFns } from "./ContestDefinitions.vue?vue&type=template&id=0144dab4&scoped=true&"
import script from "./ContestDefinitions.vue?vue&type=script&lang=js&"
export * from "./ContestDefinitions.vue?vue&type=script&lang=js&"
import style0 from "./ContestDefinitions.vue?vue&type=style&index=0&id=0144dab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0144dab4",
  null
  
)

export default component.exports